import { type IAgentAssignmentItem } from '../../../../interface/agent-assignment';
import { type CoverageState, deriveCoverage } from '../../overview/quick-analytics/utils';
import { AgentIdentityCard, ContactActions, type IContactMessageAction, StatusBlock } from '../components';

/**
 * Tab 1 — the original "Assigned Agent" view: identity card, status block, and
 * contact actions. Behaviour is unchanged from the pre-tabs drawer; it now reads
 * the shared assignment item the parent already fetched.
 */
interface IAgentTabProps {
	item: IAgentAssignmentItem;
	seed: string;
	/** In-app chat, when this agent is the reader's DIRECT child. Absent for grandchildren. */
	message?: IContactMessageAction;
}

const AgentTab = ({ item, seed, message }: IAgentTabProps) => {
	const coverage = deriveCoverage(item);
	const cov: CoverageState = coverage.state;
	const agent = item.agent;
	const showContact = !!agent && cov !== 'agentUnavailable';
	const tone: 'success' | 'neutral' =
		agent && agent.isActive && cov !== 'conflict' && cov !== 'agentUnavailable' ? 'success' : 'neutral';

	return (
		<div className='f-column-20'>
			{agent ? (
				<AgentIdentityCard
					agent={agent}
					seed={seed}
					tone={tone}
				/>
			) : null}
			<StatusBlock
				state={cov}
				meta={item.assignmentMeta}
			/>
			{showContact && agent ? (
				<ContactActions
					agent={agent}
					message={message}
				/>
			) : null}
		</div>
	);
};

export default AgentTab;
